<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled
  flat
  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    this.timer = null;
    this.requestId = 0;
    this.destroyed = false;

    GeocoderFactory().then(geocoder => {
      if (this.destroyed) {
        return;
      }

      this.geocoder = geocoder;

      if (this.search && this.search !== this.selectedText()) {
        this.querySelections(this.search);
      }
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.stopPending();
  },

  watch: {
    search(val) {
      if (!val || !val.trim()) {
        this.stopPending();
        this.items = this.select ? [this.select] : [];
        return;
      }

      if (val !== this.selectedText()) {
        this.querySelections(val);
      }
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    selectedText() {
      if (this.select && typeof this.select === "object") {
        return this.select.text;
      }

      return this.select;
    },

    stopPending() {
      this.requestId++;

      if (this.timer != null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.stopPending();

      if (!this.geocoder) {
        return;
      }

      const requestId = this.requestId;
      this.loading = true;

      this.timer = setTimeout(() => {
        this.timer = null;

        this.geocoder.autocomplete(value).then(items => {
          if (requestId !== this.requestId) {
            return;
          }

          this.items = items.slice();
        }).catch(error => {
          if (requestId !== this.requestId) {
            return;
          }

          this.items = [];
          if (!this.geocoder.isCancel(error)) {
            console.log(error); // eslint-disable-line
          }
        }).finally(() => {
          if (requestId === this.requestId) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.stopPending();
      this.$emit("change", o);
    }
  }
};
</script>
